import { userActions, candidateActions, threadActions } from 'redux/actions';
import { WebSocketClient } from 'util/webSocketClient';
import { extLocalStore } from 'util/localStorage';

const ws = {
	instance: null,
	// url will be set after /login response
	url: ''
};

export const updateWsUrl = (url) => (ws.url = url);

const getTokenCallback = () => extLocalStore.realTimeTicket;

/**
 * Redux middleware that will trigger realtime-server connection.
 * @param {Object} store => redux-store
 */
export const socketMiddleware = (store) => (next) => (action) => {
	// real-time URL & ticket will be available after sessionInfo action has fulfilled
	if (userActions.sessionInfo.fulfilled.match(action)) {
		ws.instance = new WebSocketClient(ws.url);
		const onMessageCallback = (data) => {
			if (data.message && data.thread && data.message.messageText) {
				store.dispatch(candidateActions.updateDoNotTextFlag(data.message));
				store.dispatch(threadActions.realtimeMsg(data));
			}
		};
		ws.instance.connect(
			getTokenCallback,
			null,
			onMessageCallback
		);
	}
	if (userActions.logout.fulfilled.match(action)) {
		ws.instance.close(ws.instance.NORMAL_CLOSE, 'session ended.');
	}
	return next(action);
};
